import { GatewayRoleModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/output/gateway-role.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

export interface RoleListActionsHeaderProps
  extends HeaderContext<GatewayRoleModel, unknown> {}

export const RoleListActionsHeader = (): // props: RoleListActionsHeaderProps,
ReactNode => {
  // RENDER ////////////////////////////////////////////////////////////////////

  return null;
};
